import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Modal, Row, Col } from 'react-bootstrap'
import { Button, FormText, Select } from 'src/components'
import { faCheck, faWindowClose } from '@fortawesome/free-solid-svg-icons'

import { haveAnyValue } from 'src/utils/utilitiesV2'
import { handlerError } from 'src/selectors/error.selector'
import { showAlert } from 'src/actions/alert.actions'

import { getAllPOS } from 'src/actions/restaurant.actions'
import { selectAllPOS } from 'src/selectors/restaurant.selector'

export interface ICardProviderDeviceDetailProps {
  show: boolean
  data?: ICardProviderDeviceDetail
}

interface CardProviderDeviceDetailProps extends ICardProviderDeviceDetailProps {
  onClose: () => void
  onSave: (request: ICardProviderDeviceRequest) => void
}

export const CardProviderDeviceDetail = ({
  show,
  data,
  onClose,
  onSave,
}: CardProviderDeviceDetailProps) => {
  const dispatch = useDispatch()

  const pos: IPOSSimple[] = useSelector(selectAllPOS)

  const isCreation = !data

  const [detail, setDetail] = useState<Partial<ICardProviderDeviceDetail>>({})

  useEffect(() => {
    if (!show) return
    setDetail(data ?? {})
    dispatch(getAllPOS())
  }, [show])

  const onHide = () => {
    onClose()
    setDetail({})
  }

  const onSaveData = () => {
    let errors = ''
    if (!detail.pos?.id) errors += 'Debe seleccionar un punto de venta.\n'
    if (!detail.device?.code) errors += 'Debe ingresar un código.\n'
    if (!detail.device?.name) errors += 'Debe ingresar un nombre.\n'

    if (haveAnyValue(errors)) {
      dispatch(showAlert(handlerError(errors)))
      return
    }

    onSave({
      id: isCreation ? null : data.device.id,
      posId: detail.pos.id,
      providerId: 1,
      code: detail.device.code,
      name: detail.device.name,
    })
    setDetail({})
  }

  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isCreation ? 'Crear dispositivo' : `Editar dispositivo ${data.device.name}`}
        </Modal.Title>
      </Modal.Header>
      <form
        onSubmit={e => {
          e.preventDefault()
          onSaveData()
        }}>
        <Modal.Body>
          <Row>
            <Col xl={12}>
              <FormText
                autoFocus
                label={'Código'}
                name={'code'}
                max={100}
                value={detail?.device?.code}
                changeValue={(code: string) =>
                  setDetail({ ...detail, device: { ...detail.device, code } })
                }
                required
              />
            </Col>
            <Col xl={12}>
              <FormText
                label={'Nombre'}
                name={'name'}
                max={100}
                value={detail?.device?.name}
                changeValue={(name: string) =>
                  setDetail({ ...detail, device: { ...detail.device, name } })
                }
                required
              />
            </Col>
            <Col xl={12}>
              <Select
                label={'POS'}
                name={'pos'}
                value={
                  detail?.pos
                    ? { value: detail.pos.id, label: detail.pos.name }
                    : { value: null, label: 'Seleccione un POS' }
                }
                onChange={(pos: IPOSSimple) => setDetail({ ...detail, pos })}
                options={pos}
                required
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row className={'container-buttons'}>
            <Button icon={faWindowClose} color={'secondary'} onClick={onHide}>
              Cerrar
            </Button>
            <Button icon={faCheck} color={'primary'} type={'submit'}>
              {isCreation ? 'Crear' : 'Guardar'}
            </Button>
          </Row>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
